var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlankHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 22C13.3735 22 13.2471 21.9683 13.1338 21.9047C13.0108 21.8358 10.0874 20.1872 7.12208 17.7032C5.36456 16.231 3.96164 14.7709 2.95237 13.3633C1.64632 11.5419 0.989531 9.79001 1.00013 8.1561C1.01253 6.25487 1.71365 4.46689 2.97448 3.12147C4.25661 1.75338 5.96764 1 7.79249 1C10.1312 1 12.2694 2.27239 13.5 4.28801C14.7306 2.27244 16.8689 1 19.2076 1C20.9316 1 22.5765 1.67978 23.8394 2.91413C25.2253 4.2687 26.0127 6.18265 25.9998 8.16511C25.9892 9.79617 25.3201 11.5455 24.0112 13.3643C22.9988 14.7711 21.5978 16.2307 19.8472 17.7024C16.8927 20.1862 13.9903 21.8347 13.8682 21.9036C13.7544 21.9678 13.6271 22 13.5 22Z",
    fill: "white",
    fillOpacity: 0.4,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankHeart);
export default __webpack_public_path__ + "static/media/blank-heart.7537935a72feea12b1400076f72314ad.svg";
export { ForwardRef as ReactComponent };